<script>

export default {
	props: ['item'],
	filters: {
		akcija_dane: function (value) {
			if (value) {
				return 'Da';
			} else {
				return 'Ne';
			}
		}
	},
	computed: {
		showAditionalParams () {
			if (this.item.konto_destinacije === 'TV' || this.item.konto_destinacije === 'RV0KM' || this.item.konto_destinacije === 'ND') {
				return true;
			}
			return false;
		}
	}
}
</script>

<template>
    <b-card>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Id:</b></b-col>
            <b-col sm="2">{{ item.id }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Št. naročila vozila:</b></b-col>
            <b-col sm="2">{{ item.st_narocila_vozila }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Konto lastnika:</b></b-col>
            <b-col sm="2">{{ item.konto_lastnika }}</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Št. nm:</b></b-col>
            <b-col sm="2">{{ item.st_nm }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Tip naročila:</b></b-col>
            <b-col sm="2">{{ item.tip_narocila_vozila }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Vozilo na borzi:</b></b-col>
            <b-col sm="2">{{ item.vozilo_na_borzi }}</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Obljubljeni mada:</b></b-col>
            <b-col sm="2">{{ item.obljubljeni_mada }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Predevideni mada:</b></b-col>
            <b-col sm="2">{{ item.predvideni_mada }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Realni mada:</b></b-col>
            <b-col sm="2">{{ item.realni_mada }}</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Koda naslovnika:</b></b-col>
            <b-col sm="2">{{ item.konto_naslovnika }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Koda prodajalca:</b></b-col>
            <b-col sm="2">{{ item.koda_prodajalca }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Kupec:</b></b-col>
            <b-col sm="2">{{ item.kupec }}</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Dobava v koncesijo:</b></b-col>
            <b-col sm="2">{{ item.koncesija_datum }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>DVK Lokacija:</b></b-col>
            <b-col sm="2">{{ item.koncesija_lokacija }}</b-col>

            <b-col sm="2" class="text-sm-right"><b>Zadržano:</b></b-col>
            <b-col sm="2">{{ item.zadrzano_lastnik }}</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Opomba:</b></b-col>
            <b-col sm="2"><div class="opomba_input_box">{{ item.interna_opomba }}</div></b-col>
            
            <b-col sm="2" class="text-sm-right"><b>Akcijski:</b></b-col>
            <b-col sm="2">{{ item.akcijski | akcija_dane }}</b-col>

            <b-col v-if="showAditionalParams" sm="2" class="text-sm-right"><b>Št. kilometrov:</b></b-col>
			<b-col v-if="showAditionalParams" sm="2">{{ item.st_kilometrov }}</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="2" class="text-sm-right"><b>Cena vozila brez opcij:</b></b-col>
            <b-col sm="2">{{ item.vega_baseValueWithoutOptionsVatExcluded }}</b-col>
            <b-col sm="2" class="text-sm-right"><b>Cena barve:</b></b-col>
            <b-col sm="2">{{ item.vega_coloursPclPriceVatExcluded }}</b-col>
            <b-col sm="2" class="text-sm-right"><b>Cena opcij:</b></b-col>
            <b-col sm="2">{{ item.vega_additionalPclPriceVatExcluded }}</b-col>
            <b-col sm="2" class="text-sm-right"><b>Številka pogodbe:</b></b-col>
            <b-col sm="2">{{ item.vega_contractNumber }}</b-col>
            <b-col sm="2" class="text-sm-right"><b>Prodajni kanal:</b></b-col>
            <b-col sm="2">{{ item.vega_contractSalesChannel }}</b-col>
            <b-col sm="2" class="text-sm-right"><b>Stranka:</b></b-col>
            <b-col sm="2">{{ item.vega_contractCustomerName }}</b-col>
        </b-row>
		<b-row v-if="showAditionalParams" class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Datum prve registracije:</b></b-col>
			<b-col sm="2">{{ item.datum_prve_registracije | hr_date }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Prodamo ga lahko od:</b></b-col>
			<b-col sm="2">{{ item.datum_kdaj_ga_lahko_prodamo | hr_date }}</b-col>

			<b-col sm="2" class="text-sm-right"><b>Prodati ga moramo do:</b></b-col>
			<b-col sm="2">{{ item.datum_kdaj_ga_moramo_prodati | hr_date }}</b-col>

		</b-row>
		<b-row v-if="showAditionalParams" class="mb-2">
			<b-col sm="2" class="text-sm-right"><b>Prodajna cena:</b></b-col>
			<b-col sm="2" v-if="item.prodajna_cena != null && item.prodajna_cena > 0">{{ item.prodajna_cena | hr_money }}</b-col>
			<b-col sm="2" v-else > / </b-col>

			<b-col sm="2" class="text-sm-right"></b-col>
			<b-col sm="2"></b-col>

			<b-col sm="2" class="text-sm-right"></b-col>
			<b-col sm="2"></b-col>

		</b-row>
       
    </b-card>
</template>


// WEBPACK FOOTER //
// src/components/PodrobnostiVozilaZalogaCard.vue